import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { ExportDataProvider } from "../../data-provider/export.dp";
import { Campaign } from "../../models/campaign.model";
import { Effort } from "../../models/effort.model";
import { PermissionCheck } from "../../shared/permission";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { ResultDataProvider } from "../../data-provider/result.dp";

let ResultExportComponent = {
    selector: "vcResultExportDialog",
    templateUrl: "/angular/components/result/result-export.component.html",
    bindings: {
        survey: "=?",
    },
    controller: class ResultExportController {
        // * bindings for typescript compiler *
        public survey?: any;
        // ************************************

        public efforts: Effort[] = [];
        public canvass_types: object[] = [];
        public errorMessage = false;
        public isLeaderView: boolean;
        public errors = { app: "", effort: "" };
        public params: any = {
            categories: [],
            effortsIDs: [],
            timezone: "",
            surveys: [],
        };
        public permissionProvider: PermissionCheck;
        public surveys: object[] = [];
        public activeCampaign: Campaign;
        public customDateTemplates: any;
        public dateRange: any;

        private resultDataProvider: ResultDataProvider;
        private effortDataProvider: EffortDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private surveyDataProvider: SurveyDataProvider;
        private exportDataProvider: ExportDataProvider;
        private toast: ToastUtils;
        private $location: any;
        private dialog: DialogUtils;
        public dismissDialog: () => void;

        constructor(
            DialogUtils: DialogUtils,
            $location: any,
            __app_type: string,
            PermissionCheck: PermissionCheck,
            ExportDataProvider: ExportDataProvider,
            EffortDataProvider: EffortDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            ResultDataProvider: ResultDataProvider,
            SurveyDataProvider: SurveyDataProvider,
            ToastUtils: ToastUtils
        ) {
            this.permissionProvider = PermissionCheck;
            this.isLeaderView = __app_type == "LEADER";
            this.effortDataProvider = EffortDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.surveyDataProvider = SurveyDataProvider;
            this.exportDataProvider = ExportDataProvider;
            this.resultDataProvider = ResultDataProvider;
            this.toast = ToastUtils;
            this.$location = $location;
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.effortDataProvider.getAllEfforts().then((data: Effort[]) => {
                this.efforts = _.cloneDeep(data);
                this.effortDataProvider
                    .getSelectedEffort()
                    .then((effort: Effort) => {
                        angular.forEach(this.efforts, (value: Effort) => {
                            value.checked = true;
                            this.params.effortsIDs.push(value.id);
                        });
                    });
            });
            if (!this.survey) {
                this.surveyDataProvider
                    .getAllSurveys()
                    .then((surveys: object[]) => {
                        this.surveys = surveys;
                    });
            } else {
                this.params.surveys.push(this.survey);
                this.params.surveyOnly = true;
            }

            this.activeCampaign = this.campaignDataProvider.activeCampaign;
            this.activeCampaign
                .getCampaignCanvassingType()
                .then((data: object[]) => {
                    this.canvass_types = _.cloneDeep(data);
                    this.canvass_types.forEach((value: any) => {
                        value.checked = true;
                        this.params.categories.push(value.ctname);
                    });
                });

            this.dismissDialog = function () {
                this.dialog.cancel();
            };

            this.customDateTemplates =
                this.resultDataProvider.getCustomDateTemplates();
            this.dateRange =
                this.customDateTemplates[this.customDateTemplates.length - 1];

            this.dateRange.selectedTemplate = this.dateRange.name;
            this.dateRange.selectedTemplateName = this.dateRange.name;
        }

        checkCanvassType(ctname: string): boolean {
            const index = this.params.categories.indexOf(ctname);
            return index > -1;
        }

        checkEffort(effortID: string | number): boolean {
            const index = this.params.effortsIDs.indexOf(effortID);
            return index > -1;
        }

        changeEffort(effortID: string | number): void {
            this.errorMessage = false;
            this.errors.effort = "";
            let indexEffort = this.params.effortsIDs.indexOf(effortID);
            if (indexEffort > -1) {
                this.params.effortsIDs.splice(indexEffort, 1);
            } else {
                this.params.effortsIDs.push(effortID);
            }
        }

        changeSurvey(): void {
            this.params.surveys = this.surveys
                .filter((survey: any) => survey.checked)
                .map((survey: any) => survey.sid);
        }

        changeCanvassType(ctname: string): void {
            this.errorMessage = false;
            this.errors.app = "";
            let indexCanvass = this.params.categories.indexOf(ctname);
            if (indexCanvass > -1) {
                this.params.categories.splice(indexCanvass, 1);
            } else {
                this.params.categories.push(ctname);
            }
        }

        exportData(): void {
            if (
                this.canvass_types.length > 1 &&
                !this.params.categories.length
            ) {
                this.errorMessage = true;
                this.errors.app = "Please select at least one app";
            } else if (
                this.efforts.length > 1 &&
                !this.params.effortsIDs.length
            ) {
                this.errorMessage = true;
                this.errors.effort = "Please select at least one effort";
            } else {
                this.dialog.cancel();
                this.errorMessage = false;
                this.params.start = this.dateRange.dateStart;
                this.params.end = this.dateRange.dateEnd;
                this.params.timezone =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;

                this.exportDataProvider.canvasses({ params: this.params }).then(
                    () => {
                        this.toast
                            .action("Export Started", "Show")
                            .then((value: string) => {
                                if (value == "ok") {
                                    if (this.isLeaderView) {
                                        this.$location.url("/leader_exports");
                                    } else {
                                        this.$location.url("/exports");
                                    }
                                }
                            });
                    },
                    () => this.toast.error()
                );
            }
        }
    },
};

angular
    .module("result")
    .component(ResultExportComponent.selector, ResultExportComponent);
